module.exports = __webpack_public_path__ + "static/media/data-source.b4ebabd5.png";